import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Divider,
  Form,
  Input,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
  Tooltip,
} from "antd";
import moment from "moment";

import CommissionApi from "../../../apis/Commission.api";
import CooperateApi from "../../../apis/Cooperate.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

const CooperateProductComponent = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const user = useSelector((state) => state.auth.user);

  const [searchOptions, setSearchOptions] = useState({
    product_id: null,
    product_maker_name: "",
    product_name: "",
    product_brand_name: "",
    product_status: "total",
    influencer_id: 0,
  });
  const [influencerList, setInfluencerList] = useState([
    { value: 0, label: "전체" },
  ]);
  const [productItemList, setProductItemList] = useState([]);
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  // const [selectedRow, setSelectedRow] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalSize, setTotalSize] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [orderType, setOrderType] = useState("cooperate_start_date");

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  // const [error, setError] = useState("");

  const rowSelection = {
    type: "radio",
    selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys);
      // setSelectedRow(selectedRows);
    },
  };

  const productStatusItems = [
    { label: "전체", value: "total", data: 0 },
    { label: "진행 예정", value: "unsold", data: 1 },
    { label: "진행중", value: "selling", data: 2 },
    { label: "진행 완료", value: "soldOut", data: 3 },
  ];

  const orderPair = {
    product_id: "상품번호순",
    quantity: "재고수량순",
    price_1: "판매가",
    price_2: "할인가",
    delivery_type: "배송특성순",
    delivery_price: "배송비순",
    created_at: "상품등록일순",
  };

  const getInfluencerList = async () => {
    const param = {
      page: "cooperate",
    };
    const res = await CommissionApi.readCooperateInfluencerList(param);
    if (res.code === 200) {
      setInfluencerList([
        {
          value: 0,
          label: "전체",
        },
        ...res.result.map((item) => ({
          value: item.id,
          label: item.nickname,
        })),
        {
          value: 2,
          label: "당신의 영양제",
        },
      ]);
    }
  };

  useEffect(() => {
    readCooperateProductList("initial");
    getInfluencerList();
  }, []);

  useEffect(() => {
    readCooperateProductList();
  }, [offset, pageSize, orderType, orderBy]);

  /**
   * 공동구매 목록 불러오기
   * @returns {Promise<void>}
   */
  const readCooperateProductList = async (type) => {
    setIsLoading(true);
    try {
      let param = {};
      let status = productStatusItems.find(
        (el) => el.value === searchOptions.product_status,
      );
      if (type === "initial") {
        param = {
          productId: null,
          brandName: "",
          productName: "",
          cooperateStatus: 0,
          influencerId: 0,
          orderType: "cooperate_start_date",
          orderBy: "desc",
          offset: 0,
          pageSize: 10,
          // userId: user.id === 724 ? 1 : user.id,
        };
      } else if (type === "search") {
        param = {
          productId: searchOptions.product_id,
          brandName: searchOptions.product_brand_name,
          productName: searchOptions.product_name,
          cooperateStatus: status.data,
          influencerId: searchOptions.influencer_id,
          orderType: orderType,
          orderBy: orderBy,
          offset: 0,
          pageSize: 10,
          // userId: user.id === 724 ? 1 : user.id,
        };
      } else {
        param = {
          productId: searchOptions.product_id,
          brandName: searchOptions.product_brand_name,
          productName: searchOptions.product_name,
          cooperateStatus: status.data,
          influencerId: searchOptions.influencer_id,
          orderType: orderType,
          orderBy: orderBy,
          offset: offset,
          pageSize: pageSize,
        };
      }

      const res = await CooperateApi.getProductItemCooperate(param);
      if (res.code === 200) {
        setTotalSize(res.result.totalCnt);
        setProductItemList(res.result.cooperateList);
      }
    } catch (error) {
      setIsLoading(false);
      // setError(error);
      console.log("[readCooperateProductList] read error", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "product_id") {
      const reg = /^[0-9]*$/;
      if (value === "") {
        setSearchOptions({ ...searchOptions, [name]: null });
      } else if (reg.test(value)) {
        setSearchOptions({ ...searchOptions, [name]: value });
      }
    } else if (name === "product_status") {
      setSearchOptions({ ...searchOptions, [name]: value });
    } else {
      setSearchOptions({ ...searchOptions, [name]: value });
    }
  };

  const handleSelectChange = (e, value) => {
    setSearchOptions({ ...searchOptions, influencer_id: value.value });
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("cooperate_start_date");
        setOrderBy("desc");
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const offset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(offset);
    setExpandedRowKeys([]);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset(0);
    setCurrentPageNumber(1);
  };

  /**
   * 검색 버튼
   */
  const handleSearchBtnClick = async () => {
    setOffset(0);
    setCurrentPageNumber(1);
    readCooperateProductList("search");
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      product_id: null,
      product_maker_name: "",
      product_name: "",
      product_brand_name: "",
      product_status: "total",
      influencer_id: 0,
    });
    setOffset(0);
    setPageSize(10);
    setCurrentPageNumber(1);
    setOrderType("cooperate_start_date");
    setOrderBy("desc");
    readCooperateProductList("initial");
  };

  return (
    <div style={{ position: "relative" }}>
      {/*<AbsoluteAlert text={"준비중입니다"} />*/}
      <ContentHeaderComponent title="공동구매 조회/수정" />
      <div className="product-register-wrap" style={{ marginTop: 20 }}>
        {/*상품검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            label="검색어"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle" style={{ marginBottom: 15 }}>
              <label className="product-search-box-input-label">상품번호</label>
              <Input
                className="product-search-box-input-wrap"
                name="product_id"
                value={
                  searchOptions.product_id === 0 ? "" : searchOptions.product_id
                }
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
              <label className="product-search-box-input-label">상품명</label>
              <Input
                className="product-search-box-input-wrap"
                name="product_name"
                value={searchOptions.product_name}
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
            </Row>
            <Row align="middle">
              <label className="product-search-box-input-label">브랜드명</label>
              <Input
                className="product-search-box-input-wrap"
                name="product_brand_name"
                value={searchOptions.product_brand_name}
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="공구 상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              name="product_status"
              value={searchOptions.product_status}
              options={productStatusItems}
              onChange={handleChange}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="인플루언서"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              className="product-search-category-select"
              placeholder="전체"
              name="influencer_id"
              value={searchOptions.influencer_id}
              options={influencerList}
              onChange={(e, value) => handleSelectChange(e, value)}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          {/*<Form.Item*/}
          {/*    className="center-label"*/}
          {/*    label="기간"*/}
          {/*    labelAlign="left"*/}
          {/*    colon={false}*/}
          {/*    labelCol={{ span: 3 }}*/}
          {/*    wrapperCol={{ span: 21 }}*/}
          {/*>*/}

          {/*</Form.Item>*/}
          {/*<Divider className="product-register-form-input-divider" />*/}
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearchBtnClick}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*공동구매 목록*/}
        <Row
          className="product-register-border-box"
          wrap={false}
          justify={"space-between"}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <span className="product-register-box-title">
            공동구매 목록 (총{" "}
            <span
              className="product-register-box-subtitle"
              style={{ marginLeft: 0 }}
            >
              {totalSize}
            </span>
            개)
          </span>
          <span
            style={{
              alignSelf: "end",
              paddingBottom: "0.25rem",
              color: "#868e96",
              fontSize: "13px",
            }}
          >
            ※ 외부 상품의 경우 상품번호가 -로 표기됩니다.
          </span>
          {/*<span className="product-list-subtitle">{orderPair[orderType]}</span>*/}
        </Row>
        <div
          className="product-register-border-box"
          style={{ padding: "20px 25px 40px", height: "fit-content" }}
        >
          {/*<Table*/}
          {/*	rowSelection={rowSelection}*/}
          {/*	columns={columns}*/}
          {/*	dataSource={productItemList}*/}
          {/*	loading={isLoading}*/}
          {/*	bordered*/}
          {/*	size="middle"*/}
          {/*	rowKey="id"*/}
          {/*	rowClassName="coupon-table-row"*/}
          {/*	scroll={{ x: "calc(700px + 50%)" }}*/}
          {/*	onChange={tableOnChange}*/}
          {/*	pagination={false}*/}
          {/*/>*/}
          <CooperateTable
            productItemList={productItemList}
            setOrderType={setOrderType}
            setOrderBy={setOrderBy}
            expandedRowKeys={expandedRowKeys}
            setExpandedRowKeys={setExpandedRowKeys}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              pageSize={pageSize}
              showSizeChanger
              onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * 공동구매 목록 테이블 render
 * @param productItemList
 * @returns {JSX.Element}
 * @constructor
 */
const CooperateTable = ({
  productItemList,
  setOrderType,
  setOrderBy,
  expandedRowKeys,
  setExpandedRowKeys,
}) => {
  let history = useHistory();

  const handleRowExpand = (expanded, record) => {
    const keys = expanded
      ? [...expandedRowKeys, record.key]
      : expandedRowKeys.filter((key) => key !== record.key);
    setExpandedRowKeys(keys);
  };

  /**
   * 공동구매 링크 복사
   * @param target_id
   * @param purchase_url
   */
  const copyCooperateLink = (target_id, purchase_url) => {
    let link = "";
    if (purchase_url) {
      if (purchase_url.includes("smartstore")) {
        link += purchase_url;
      } else {
        link += `https://www.dangyoung.com/products/group_buying/${target_id}?query=${purchase_url}`;
      }
      navigator.clipboard.writeText(link);
      alert("링크가 복사되었습니다.");
      // window.open(link, "_blank");
    }
  };

  /**
   * 공동구매 상품 옵션 컬럼 render
   * @returns {JSX.Element}
   */
  const expandedRowRender = (record) => {
    const columns = [
      {
        title: "옵션 아이디",
        dataIndex: "id",
        key: "id",
        // fixed: "left",
        width: 50,
        align: "center",
      },
      {
        title: "옵션명",
        dataIndex: "option_title",
        key: "option_title",
        width: 100,
        align: "center",
      },
      {
        title: "공구가",
        key: "price_2",
        dataIndex: "price_2",
        width: 100,
        align: "center",
        render: (value) => {
          return value?.toLocaleString();
        },
      },
      {
        title: "박스 당 가격",
        key: "option_description",
        dataIndex: "option_description",
        width: 100,
        align: "center",
        render: (value) => {
          return Number(value)?.toLocaleString();
        },
      },
    ];

    /**
     * 공동구매 상품별 옵션 테이블
     */
    return (
      <Table
        columns={columns}
        dataSource={record.optionList.map((item, idx) => {
          return {
            ...item,
            key: idx?.toString(),
          };
        })}
        pagination={false}
        bordered
      />
    );
  };

  /**
   * 공동구매 상품 목록 컬럼 render
   * @type {[{dataIndex: string, width: number, title: string, render: (function(*): *), key: string, ellipsis: boolean},{dataIndex: string, width: number, title: string, render: ((function(*): (*))|*), key: string, ellipsis: boolean},{dataIndex: string, width: number, title: string, key: string, ellipsis: boolean},{dataIndex: string, width: number, title: string, render: ((function(*): *)|*), key: string, ellipsis: boolean},{dataIndex: string, width: number, title: string, key: string, ellipsis: boolean},null,null]}
   */
  const columns = [
    {
      title: "공구 기간",
      width: 300,
      dataIndex: "cooperate_start_date",
      key: "cooperate_start_date",
      ellipsis: true,
      align: "center",
      fixed: "left",
      sorter: () => {},
      // fixed: "left",
      render: (value, record) => {
        const start = moment(record.cooperate_start_date).format(
          "YYYY.MM.DD HH:mm",
        );
        const end = moment(record.cooperate_end_date).format(
          "YYYY.MM.DD HH:mm",
        );
        return (
          <span>
            {start} ~ {end}
          </span>
        );
      },
    },
    {
      title: "인플루언서",
      width: 100,
      dataIndex: "influencer_name",
      key: "influencer_name",
      ellipsis: true,
      align: "center",
      sorter: () => {},
      render: (value, record) => {
        if (record.name) {
          return record.name;
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "상품번호",
      width: 90,
      dataIndex: "product_id",
      key: "product_id",
      ellipsis: true,
      align: "center",
      sorter: () => {},
      render: (value) => {
        if (value === 0) {
          return <span>-</span>;
        } else {
          return <span>{value}</span>;
        }
      },
    },
    {
      title: "브랜드명",
      width: 120,
      dataIndex: "product_brand_name",
      key: "product_brand_name",
      ellipsis: true,
      align: "center",
    },
    {
      title: "상품명",
      width: 230,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
      align: "center",
      sorter: () => {},
      render: (value) => {
        if (value) {
          return value;
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "공구 상태",
      width: 90,
      dataIndex: "cooperate_status",
      key: "cooperate_status",
      ellipsis: true,
      align: "center",
      render: (value) => {
        switch (value) {
          case 0:
            return (
              <span style={{ color: "#117ffa", fontWeight: "600" }}>
                진행중
              </span>
            );
          case 1:
            return <span style={{ fontWeight: "600" }}>진행 예정</span>;
          case 2:
            return <span>진행 완료</span>;
          default:
            break;
        }
      },
    },
    {
      title: "마감 여부",
      width: 90,
      dataIndex: "is_sold_out",
      key: "is_sold_out",
      ellipsis: true,
      align: "center",
      render: (value) => {
        if (value) {
          return <span style={{ color: "red" }}>마감</span>;
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "노출 여부",
      width: 90,
      dataIndex: "is_hidden",
      key: "is_hidden",
      ellipsis: true,
      align: "center",
      render: (value) => {
        if (value === null || value === undefined) {
          return <span>-</span>;
        } else if (value === true) {
          return (
            <span style={{ color: "red", fontWeight: "600" }}>미노출</span>
          );
        } else {
          return <span>노출</span>;
        }
      },
    },
    {
      title: "커미션율",
      width: 90,
      dataIndex: "commission_rate",
      key: "commission_rate",
      ellipsis: true,
      align: "center",
      sorter: () => {},
      render: (value) => {
        return <span>{value}%</span>;
      },
    },
    {
      title: "링크",
      width: 90,
      dataIndex: "purchase_url",
      key: "purchase_url",
      ellipsis: {
        showTitle: false,
      },
      align: "center",
      render: (value, record) => {
        if (value) {
          let link = "";
          if (record?.purchase_url.includes("smartstore")) {
            link = value;
          } else {
            link = `https://www.dangyoung.com/products/group_buying/${record?.target_id}?query=${value}`;
          }
          return (
            <Tooltip placement="topLeft" title={link}>
              <a
                onClick={(e) => {
                  e.stopPropagation();
                  copyCooperateLink(record?.target_id, value);
                }}
              >
                링크 복사
              </a>
            </Tooltip>
          );
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "수정",
      width: 90,
      key: "edit_cooperate",
      ellipsis: true,
      align: "center",
      render: () => <a>수정하기</a>,
      onCell: (record) => {
        return {
          // onClick: (e) => onClickProduct(e, record),
          onClick: (e) => {
            e.stopPropagation();
            history.push(
              `/product/cooperate_register/${record.cooperate_id}/${record.influencer_id}`,
            );
          },
        };
      },
    },
  ];

  /**
   * 공동구매 수정하기 버튼 클릭 시 실행
   * @param e
   * @param record
   */
  const onClickProduct = (e, record) => {
    // e.preventDefault();
    history.push(`/product/cooperate_register/${record.product_id}`);
  };

  /**
   * 공동구매 목록 테이블 정렬 변경
   * @param pagination
   * @param filters
   * @param sorter
   * @param extra
   */
  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("cooperate_start_date");
        setOrderBy("desc");
      }
    }
  };

  /**
   * 공동구매 상품 테이블
   */
  return (
    <Table
      columns={columns}
      expandable={{
        expandedRowRender,
        expandedRowKeys,
        onExpand: handleRowExpand,
      }}
      expandRowByClick={true}
      dataSource={productItemList.map((item, idx) => {
        return {
          ...item,
          key: idx?.toString(),
        };
      })}
      onChange={tableOnChange}
      scroll={{ x: "calc(700px + 50%)" }}
      className="cooperate-table-expand-icon"
      pagination={false}
      size="middle"
      bordered
    />
  );
};

export default CooperateProductComponent;
